/**
 * Maximum number of authorized drivers on one permit at monthly signup.
 *
 * ## Invariants:
 * - The cap is the TOTAL driver count and includes the account holder that the signup form
 *   auto-seeds as driver #1 (so a customer can add at most two more).
 *   Why: parity with the legacy reservation site's `Vehicles.tsx` cap of 3 (PB-6991).
 * - The cap is client-side only; the API enforces no driver-count limit.
 */
export const MAX_AUTHORIZED_DRIVERS = 3;
